import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=b2b7b45a&"
import script from "./ActionMenu.vue?vue&type=script&lang=js&"
export * from "./ActionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports